import React, { ReactElement, useState } from 'react'
import { Controller } from 'react-hook-form'
import { CircularProgress, InputAdornment, Autocomplete as MUIAutocomplete, TextField, styled } from '@mui/material'

const SelectWrapper = styled('div')(() => ({
  marginTop: '0.8rem',
  marginBottom: '1.5rem',
  '> div > div > div': {
    marginTop: '20px',
  },
  'label[data-shrink="true"]': {
    fontSize: '1.3rem',
  },
}))

type Option = { label: string; value: string | number }
type Props = {
  label: String
  name: string
  control: any
  options: Option[]
  disabled?: boolean
  loadingOptions?: boolean
  onInputChange?: (inputValue: string) => void
}
export function Autocomplete({
  label,
  name,
  control,
  options,
  disabled,
  loadingOptions,
  onInputChange,
}: Props): ReactElement {
  const [selectedOption, setSelectedOption] = useState<Option | null>(null)

  const onSelectOption = (newValue: unknown) => {
    let newSelectedOption = newValue
    if (typeof newValue !== 'object') {
      newSelectedOption = options.find((it) => it.value === newValue)
    }
    setSelectedOption(newSelectedOption as Option)
  }

  return (
    <SelectWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value: newValue } }) => {
          onSelectOption(newValue)
          return (
            <MUIAutocomplete
              disablePortal
              getOptionLabel={(op) => op.label || ''}
              options={options}
              sx={{ width: '100%' }}
              onChange={(_: any, newSelectedOption: any) => {
                onChange(newSelectedOption)
              }}
              onInputChange={(_: any, newInputValue) => {
                onInputChange?.(newInputValue)
              }}
              value={selectedOption}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    variant="standard"
                    label={label}
                    InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <div>
                          {!loadingOptions && params.InputProps.endAdornment}
                          {loadingOptions && (
                            <InputAdornment position="end" style={{ position: 'absolute', right: '2px' }}>
                              <CircularProgress color="inherit" size={20} />
                            </InputAdornment>
                          )}
                        </div>
                      ),
                    }}
                  />
                )
              }}
              disabled={disabled}
            />
          )
        }}
      />
    </SelectWrapper>
  )
}
